import { Injectable } from "@angular/core";
import { DashboardService } from "../dashboard.service";
import { BehaviorSubject } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { AlertService } from "../../alert.service";
import { StorageService } from "../../storage.service";
import { OverviewRefundsSummaryAPIResponse } from "../../../_models";

@Injectable({
  providedIn: "root",
})
export class OverviewRefundsSummaryService extends DashboardService {
  route = "refund_report/summary";
  protected data: BehaviorSubject<OverviewRefundsSummaryAPIResponse> = new BehaviorSubject<OverviewRefundsSummaryAPIResponse>(undefined);

  constructor(
    protected http: HttpClient,
    protected alertService: AlertService,
    protected storageService: StorageService
  ) {
    super(http, alertService, storageService);
  }

  getData() {
    this.getPostData();
  }
}
